import {defaultAxios, constants} from '../data/httpWithAxios';

export default {
    phoneInfo: {
        vendorPhonebookNo: 0,
        empNo: 0,
        newPhoneNo: null 
    },    
    useageHistory: function(query) {
        return defaultAxios(constants.contentType.application_json)
            .get('/rc/cs/web/corp/orderHistory', {
                params: query
            }).then(response => {
                return response;
            });
    }
}


// WEBPACK FOOTER //
// ./src/api/useageHistory.js